import React from "react";
import _ from "lodash";
import XText from "./XText";
import XDiv from "./XDiv";

/**
 * @typedef {import("./XDiv").xdivparams} xdivparams
 * 
 * @typedef {Object} vstackparamsex
 * @property {any} children
 * @property {Number | String} width
 * @property {Number} spacing
 * @property {"[" | "|" | "]"} HAlign
 * @property {"^" | "-" | "_"} VAlign
 * 
 * @typedef {vstackparamsex & xdivparams} vstackparams
 * 
 * @param {vstackparams} param0
 */
function VStack({
  children = null,
  width = "auto",
  spacing = 0, 
  HAlign = undefined,
  VAlign = undefined,
  ...others}){

  function renderChildren(_c){
    if(React.isValidElement(_c)){
      return React.cloneElement(_c, 
        {
          ..._c.props, 
          style: {
            marginBottom: _c.props.margin 
              || _c.props.marginBottom 
              || (_c.props.style && _c.props.style.marginBottom) 
              || spacing,
            ..._c.props.style,
          }
        });
    }else{
      return _.map(_c, (o, i) => {
        if(!o){
          return null;
        }else if(_.isArray(o)){
          return _.map(o, (v, x) => {
            return renderChildren(v);
          });
        }else if(_.isString(o)){
          return <XText key={i}>{o}</XText>;
        }else if(!React.isValidElement(o)){
          console.log(o);
          //return o;
        }else if(i === _c.length - 1 || !o.props || !spacing){
          return React.cloneElement(o, {...o.props, key: i});
        }else{
          return React.cloneElement(o, 
            {
              ...o.props, 
              key: i, 
              style: {
                marginBottom: o.props.margin 
                  || o.props.marginBottom 
                  || (o.props.style && o.props.style.marginBottom) 
                  || spacing,
                ...o.props.style,
              }
            });
        }
      });
    }
  }

  let _justifyContent = "center";
  let _alignItems = "center";

  switch(VAlign){
    default: case "^": _justifyContent = "flex-start"; break;
    case "-": _justifyContent = "center"; break;
    case "_": _justifyContent = "flex-end"; break;
  }

  switch(HAlign){
    case "[": _alignItems = "flex-start"; break;
    default: case "|": _alignItems = "center"; break;
    case "]": _alignItems = "flex-end"; break;
  }

  return (
    <XDiv 
      width={width}
      display="flex"
      flexDirection="column"
      alignItems={_alignItems}
      justifyContent={_justifyContent}
      {...others}>
      {renderChildren(children)}
    </XDiv>
  );
}

export default VStack;